import { assetsRoot } from "config";
import React, { JSX, useContext } from "react";
import Image from "next/image";
import { ModalContext } from "context/modal";
import { useScreenSize } from "@pepdirect/v3/hooks/useScreenSize";
import { useRouterWithRedirect } from "hooks/useRouterWithRedirect";
import { Button } from "@pepdirect/v3/ui/Button";
import { Heading } from "@pepdirect/v3/ui/Heading";
import { getCheckoutUrl } from "helpers/cart";
import {
  logSignIn,
  logSignUp,
  logEvent,
} from "@pepdirect/v3/helpers/analyticsLogger";
import { EVENT_NAMES, LOGIN_LOCATION_ENUM } from "@pepdirect/v3/types";
import { UserContext } from "context/user";
import st from "./checkoutModal.module.scss";

export function CheckoutModal(): JSX.Element {
  const { currentUserId } = useContext(UserContext);
  const checkoutUrl = getCheckoutUrl();
  const { open, close } = useContext(ModalContext);
  const { isMobile } = useScreenSize();

  const { pushPreserveRedirect } = useRouterWithRedirect();

  const goToSignIn = () => {
    logEvent(null, EVENT_NAMES.cartLoginRedirect);
    logSignIn(LOGIN_LOCATION_ENUM.checkoutModal);
    if (isMobile) {
      close(currentUserId);
      pushPreserveRedirect("/sign-in");
    } else {
      open("LOGIN_MODAL");
    }
  };

  const goToSignUp = () => {
    close(currentUserId);
    pushPreserveRedirect("/sign-up");
    logSignUp(LOGIN_LOCATION_ENUM.checkoutModal);
  };

  return (
    <div className={st.wrapper}>
      <Image
        alt="poppi logo"
        src={`${assetsRoot}/website-assets/pepsi-drips-logo-dark.svg`}
        unoptimized
        width="160"
        height="80"
        className={st.logo}
        style={{
          maxWidth: "100%",
          height: "auto",
        }}
      />
      <div className={st.content}>
        <div className={st.block}>
          <div className={st.title}>
            <Heading level="h2" size="l">
              New to poppi?
            </Heading>
          </div>
          <div>
            Create an account for fast and simple checkout on your next order.
          </div>
          <ul className={st.list}>
            <li>View all orders in the account dashboard.</li>
            <li>Save your preferred shipping address.</li>
            <li>Add multiple payment methods.</li>
          </ul>
          <div className={st.button}>
            <Button fullWidth onClick={goToSignUp}>
              Create An Account
            </Button>
          </div>
        </div>
        <div className={st.block}>
          <Heading level="h2" size="l">
            No account?
          </Heading>
          <div>Continue with our guest checkout.</div>
          <div className={st.button}>
            <Button
              type="tertiary"
              fullWidth
              onClick={(e) => {
                e.preventDefault();
                window.open(checkoutUrl, "_self");
                logEvent(null, EVENT_NAMES.userContinueAsGuest);
              }}
            >
              Continue As Guest
            </Button>
          </div>
          <div className={st.note}>
            <span>Already have an account? </span>
            <Button type="text" onClick={goToSignIn}>
              Log in now
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
